import {
  currentBaseUrl,
  currentToken,
  currentUser,
  currentUserId,
  currentProfile,
  isUserLoggedIn,
  setProfileData,
  currentDesignation,
  currentSubscriptionLevel,
  isLessonsEnabled,
  hasActiveSubscription,
  currentAvatar,
  currentTargetGroup
} from '../common/services';

import {
  STRIPE_KEY
} from '../common/env';

// fixtures API for mocking and testing
import fixturesAPI from './API/fixtures';

// v1 api here
import BaseAPI from './API/v1/Base';
import PlBaseAPI from './API/v1/PlBase';
import AdminAPI from './API/v1/Admin';
import StudentsAPI from './API/v1/Students';
import ParentsAPI from './API/v1/Parents';
import TeachersAPI from './API/v1/Teachers';
import InstitutionsAPI from './API/v1/Institutions';


const LoadState = {
  NotLoaded: 'not_loaded',
  Loaded: 'loaded',
};

export default class Services {
  public fixturesAPI: object;
  public baseAPI: object;
  public adminAPI: object;
  public plBaseAPI: object;
  public studentsAPI: object;
  public parentsAPI: object;
  public teachersAPI: object;
  public institutionsAPI: object;
  private state: string;
  private context: any;
  private afterLoadHooks: any;

  constructor(context) {
    this.state = LoadState.NotLoaded;
    this.afterLoadHooks = [];

    this.context = context;

    // fixtures API
    this.fixturesAPI = fixturesAPI;

    // v1 API
    this.baseAPI = new BaseAPI(this);
    this.adminAPI = new AdminAPI(this);
    this.teachersAPI = new TeachersAPI(this);
    this.studentsAPI = new StudentsAPI(this);
    this.parentsAPI = new ParentsAPI(this);
    this.institutionsAPI = new InstitutionsAPI(this);
    this.plBaseAPI = new PlBaseAPI(this);

    this.state = LoadState.Loaded;
    this.afterLoadHooks.forEach((e) => { e(); });
  }

  public afterLoad(cb) {
    // We're already loaded, execute
    if (this.state === LoadState.Loaded) {
      cb(this);
      return;
    }

    // Add to queue
    this.afterLoadHooks.push(cb);
  }

  /**
   * get the redux store here. it will come in handy
   * @return [the store]
   */
  get store() {
    return this.context.store;
  }

  /**
   * attach the store dispatch here
   * @param  action [the action to be dispatched]
   */
  public dispatch(action) {
    this.store.dispatch(action);
  }

  /**
   * get the user's authentication token here so that it's
   * available for all services to use
   * @return [auth token, JWT etc...]
   */
  get authToken() {
    return currentToken();
  }
  get stripeKey() {
    return STRIPE_KEY;
  }
  get currentUsername() {
    return currentUser();
  }

  get currentUserID() {
    return currentUserId();
  }

  get currentBaseUrl() {
    return currentBaseUrl();
  }

  get currentUserProfile() {
    return currentProfile();
  }

  get isUserLoggedIn() {
    return isUserLoggedIn();
  }

  get currentSubscriptionLevel() {
    return currentSubscriptionLevel();
  }

  get currentDesignation() {
    return currentDesignation();
  }

  set setProfileData(data) {
    setProfileData(data);
  }

  get isLessonsEnabled() {
    return isLessonsEnabled();
  }

  get currentTargetGroup() {
    return currentTargetGroup();
  }
  get hasActiveSubscription() {
    return hasActiveSubscription();
  }
  get currentAvatar() {
    return currentAvatar();
  }
}



// WEBPACK FOOTER //
// ./src/services/Services.ts